import { jsx as c, jsxs as v } from "@emotion/react/jsx-runtime";
import { useRef as w, useEffect as l } from "react";
import { AnimatePresence as A } from "motion/react";
import { createPortal as E } from "react-dom";
import { MotionBackdrop as g, MotionDrawerContainer as h, StyledIconButton as C, ANIMATION_DURATION_IN_MS as f } from "./Drawer.styled.js";
import { FontAwesomeIconsPartooUsed as D } from "../../types/components/icon.js";
const T = ({
  dataTrackId: d,
  onHide: e,
  direction: m = "right",
  isOpen: o = !1,
  hideOnClose: u = !0,
  isFullWidth: p = !1,
  width: x = "400px",
  hideOnClickOutside: r = !0,
  hideOnEsc: n = !0,
  cssContainer: y,
  children: k,
  targetContainer: I = document.body
}) => {
  const i = w(null);
  l(() => {
    const t = (a) => {
      o && i.current === a.target && e();
    };
    return r && document.addEventListener("click", t), () => {
      r && document.removeEventListener("click", t);
    };
  }, [r, o, i]), l(() => {
    const t = (a) => {
      a.key === "Escape" && e();
    };
    return n && document.addEventListener("keydown", t), () => {
      n && document.removeEventListener("keydown", t);
    };
  }, [n]);
  const s = m === "right";
  return E(/* @__PURE__ */ c(A, { children: o && /* @__PURE__ */ c(g, { ref: i, initial: {
    opacity: 0
  }, animate: {
    opacity: 1
  }, exit: {
    opacity: 0
  }, transition: {
    duration: f / 1e3
  }, children: /* @__PURE__ */ v(h, { initial: {
    x: s ? "100%" : "-100%"
  }, animate: {
    x: "0%"
  }, exit: {
    x: s ? "100%" : "-100%"
  }, transition: {
    duration: f / 1e3
  }, isFullWidth: p, width: x, direction: m, cssContainer: y, children: [
    u && /* @__PURE__ */ c(C, { "aria-label": "Close", dataTrackId: `${d}-close-modal`, icon: [D.faClose], onClick: e }),
    k
  ] }) }) }), I);
};
export {
  T as Drawer
};
